import React, { useState, useEffect } from 'react';
import api from './api/axiosInstance';
import Sidebar from './Sidebar.js';
import { Card, Row, Col, Container, Button, Nav } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { TicketCountContext } from './TicketCountContext';
import Breadcrumb from './Breadcrumb.js';
import CityGeneralInfo from './CityGeneralInfo.js';
import NavTabs from './NavTabs';
import CityJobsCard from './CityJobsCard';
import { exportCityPdf } from './api/exportCityPdf.js';

const CityEditJobs = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { ticketCount } = React.useContext(TicketCountContext);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        name: '',
        country: {},
        url: '',
    });

    const userNavItems = [
        { to: '/city-edit/:id', eventKey: 'cityInfo', label: 'About' },
        { to: '/city-edit-companies/:id', eventKey: 'companies', label: 'Companies & Jobs', alsoActive: [`/city-edit-jobs/${id}`] },
        { to: '/city-edit-salary/:id', eventKey: 'salariesInfo', label: 'Average salaries' },
        { to: '/city-edit-insights/:id', eventKey: 'cityInsights', label: 'City insights' },
        { to: '/city-edit-universities/:id', eventKey: 'universities', label: 'Universities' },
        { to: '#', eventKey: 'cityComments', label: 'Comments' },
        { to: '/city-edit-history/:id', eventKey: 'history', label: 'History of changes' },
    ];

    useEffect(() => {
        const fetchCity = async () => {
            try {
                const res = await api.get(`/api/cities/${id}`);
                const data = res?.data || {};
                setFormData({
                    name: data.name || '',
                    country: (data.country && typeof data.country === 'object') ? data.country : {},
                    url: data.url || '',
                });
            } catch (error) {
                console.error('Error fetching city:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCity();
    }, [id]);

    const handleExportPdf = async () => {
        try {
            await exportCityPdf(id);
        } catch (error) {
            console.error('Error exporting city PDF:', error);
            alert('An error occurred while exporting the city PDF.');
        }
    };

    return (
        <>
            <Sidebar ticketCount={ticketCount} />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            <Breadcrumb cityName={formData.name} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body className="pt-0">
                                    <Row>
                                        <Col xs={12}>
                                            <>
                                                <Row>
                                                    <Col>
                                                        <CityGeneralInfo formData={formData} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-5">
                                                    <Col>
                                                        <NavTabs items={userNavItems} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col>
                                                        <Nav variant="pills" className="nav-pills-view-toggle">
                                                            <Nav.Item>
                                                                <Nav.Link onClick={() => navigate(`/city-edit-companies/${id}`)}>
                                                                    Companies
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link active>
                                                                    Jobs
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        {!loading && (
                                                            <CityJobsCard cityName={formData.name} cityId={id} />
                                                        )}
                                                    </Col>
                                                </Row>
                                            </>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="buttons-row">
                        <Col>
                            <Button variant="outline-secondary" className="ms-3" onClick={() => navigate('/onboarding-city-list')}>
                                Cancel
                            </Button>
                            <Button variant="outline-secondary" onClick={handleExportPdf}>
                                Download city report
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </main>
        </>
    );
};

export default CityEditJobs;
